<template>
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIE NR ...</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez: 
</p>
<p>
  <strong>...</strong>,
</p>
<p>a</p>
<br/>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko:
  <br/>
  Pesel:
  <br/>
  Adres:
  <br/>
  <br/>
  <strong>Okres trwania umowy i okres wypowiedzenia:</strong>
  <br>
  Okres trwania umowy:
  <br>
  Okres wypowiedzenia:
  <br/>
  <p><strong>Wynagrodzenie:</strong></p>
  Kwota brutto:<strong> ... PLN /godzinę</strong>
  <br>
  <br>
  <p align="center"><strong>Warunki umowy</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p>Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol type="a">
  <li>obsługa telefonicznego biura obsługi klienta Zleceniodawcy,</li>
  <li>udzielanie informacji w zakresie oferowanych przez Zleceniodawcę usług i produktów,</li>
  <li>świadczenie pomocy w korzystaniu z produktów bądź usług oferowanych przez Zleceniodawcę,</li>
  <li>przyjmowanie od klientów Zleceniodawcy telefonicznych zleceń i reklamacji,</li>
  <li>przeprowadzanie telefonicznej kampanii marketingowej,</li>
  <li>przeprowadzanie sondaży telefonicznych.</li>
</ol>
<br>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie zdalnie za pośrednictwem platform udostępnionych przez Zleceniodawcę. Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform online niezbędnych do przeprowadzenia telefonicznej kampanii oraz kontaktu z klientami.</li>
  <li>Zleceniobiorca zobowiązany jest zorganizować sprzęt elektroniczny (komputer, mikrofon, sprzęt nagłaśniający, itp.) niezbędny do zrealizowania przedmiotu umowy, na własny koszt.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
  <li>Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.
</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Realizacja przedmiotu zlecenia</strong>
</p>
<ol>
  <li>Strony ustalają wspólnie, iż Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością, tj.:
    <br>
    <ol type="a">
      <li>rzetelnie i dokładnie udzielać informacji klientom w zakresie oferowanych przez Zleceniodawcę usług i produktów, jak również ustawiać poprawne statusy w systemie CRM niezwłocznie po zakończeniu rozmowy z klientem,</li>
      <li>przestrzegać określonych przez Zleceniodawcę wytycznych prowadzenia rozmowy telefonicznej z klientem,</li>
      <li>rozłączać pocztę głosową bezpośrednio po rozpoczęciu nagrania,</li>
      <li>rzetelnie i dokładnie ewidencjonować godziny wykonywania zlecenia za pomocą udostępnionych przez Zleceniodawcę narzędzi, o których mowa w § 5 ust.2,</li>
      <li>udzielać informacji osobie wskazanej przez Zleceniodawcę o niezakończonych zadaniach w ramach realizacji przedmiotu zlecenia w danym dniu,</li>
      <li>nie korzystać z prywatnego telefonu podczas realizacji zlecenia, z wyłączeniem przerw.</li>
    </ol>
  </li>
  <li>W przypadku, gdy Zleceniobiorca realizuje zlecenie w siedzibie Zleceniodawcy, Zleceniobiorca zobowiązuje się do dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia, oraz o niespożywanie posiłków podczas rozmów telefonicznych z klientem Zleceniodawcy (posiłki są spożywane tylko w wyznaczonych miejscach biura Zleceniodawcy).</li>
  <li>W ramach ustalonej przez obie strony dyspozycyjności Zleceniobiorca realizuje powierzone czynności w określonych godzinach, uwzględniając w tym czasie przerwy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Termin i sposób zapłaty wynagrodzenia </strong>
</p>
<ol>
  <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, do 15-tego dnia następnego miesiąca, w wysokości wynikającej ze stawki godzinowej oraz liczby godzin przepracowanych w danym miesiącu, w oparciu o zestawienie (wygenerowane z narzędzi do ewidencjonowania godzin udostępnionych przez Zleceniodawcę), o którym mowa w ust. 2 poniżej.</li>
  <li>Zleceniobiorca jest zobowiązany do uzupełnienia w formie elektronicznej zestawienia liczby godzin przepracowanych w danym miesiącu najpóźniej w pierwszym dniu roboczym następnego miesiąca. Zweryfikowane przez Zleceniodawcę zestawienie będzie stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Premia i benefity</strong>
  </p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową za wyniki osiągnięte w ramach wykonanego zlecenia. Premia jest naliczana w wysokości do 1 600 (słownie: jeden tysiąc sześćset) złotych brutto za każdy miesiąc. Wysokość jest uzależniona od stopnia realizacji określonych celów indywidualnych przez zleceniobiorcę oraz od jakości prowadzonych rozmów telefonicznych zgodnie z określonymi wytycznymi przez Zleceniodawcę. Ocena jakości rozmów będzie dokonywana na podstawie monitoringu rozmów telefonicznych prowadzonych przez Zleceniobiorcę.</li>
  <li>Zleceniodawca zastrzega sobie prawo do zmiany wysokości premii w zależności od zadań aktualnie realizowanych przez Zleceniobiorcę. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać premię uznaniową w wysokości 400,00 (czterystu) złotych lub 300,00 (trzystu) złotych w zależności od rodzaju prowadzonej kampanii sprzedażowej. Premia ta jest naliczana w przypadku realizacji zlecenia w wymiarze przekraczającym określoną liczbę godzin w danym miesiącu. Liczba godzin w danym miesiącu będzie ustalana przez Zleceniodawcę lub osobę przez niego wyznaczoną z odpowiednim wyprzedzeniem.</li>
  <li>W przypadku niestosowania się do postanowień wskazanych w §4 jak również udzielania błędnych informacji klientom, Zleceniodawca może obniżyć ww. premie w zależności od ilości upomnień przekazywanych Zleceniobiorcy tj. w przypadku:
  <br>
  <ul>
    <li>pierwszego ostrzeżenia premia miesięczna zostanie obniżona o 50%,</li>
    <li>drugiego ostrzeżenia premia miesięczna zostanie obniżona o 80%,</li>
    <li>kolejnego ostrzeżenia premia miesięczna  zostanie obniżona o 100%.</li>
  </ul>
</li>
<li>Zleceniobiorca w trakcie trwania umowy zlecenie ma możliwość zakupu, po 3 miesiącach realizacji zlecenia, usługi dostępu do obiektów sportowo-rekreacyjnych po cenach niższych niż detaliczne ceny rynkowe. Zleceniodawca finansuje część tego świadczenia. Szczegółowe warunki finansowania świadczeń przez Zleceniodawcę zostaną ogłoszone przez Zleceniodawcę elektronicznie w formie wiadomości mailowej.</li>
<li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
<li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Klauzula poufności</strong>
</p>
<ol>
  <li>Strony, w związku z zawarciem niniejszej umowy zobowiązane są zapewnić należytą ochronę informacji poufnych przekazanych sobie dla potrzeb realizacji niniejszej umowy, w szczególności poprzez odebranie od podmiotów trzecich stosownych oświadczeń woli.</li>
  <li>Za poufne Strony uznają w szczególności materiały, dokumenty i informacje dotyczące kwestii:
    <br>
    <ol type="a">
      <li>finansowych,</li>
      <li>technicznych,</li>
      <li>handlowych,</li>
      <li>know – how,</li>
      <li>koncepcji,</li>
      <li>strategii,</li>
      <li>źródeł i sposobów finansowania.</li>
      <br>
    </ol>
    <p>Za poufne Strony nie uznają w szczególności materiałów, dokumentów i informacji, które:</p>
    <ol type="a">
    <li>w dacie ich ujawnienia stanowią informacje dostępne publicznie,</li>
    <li>są już w dacie podpisania niniejszej umowy znane Stronom i wiedza ta została nabyta zgodnie z prawem, w sposób niezwiązany z realizacją przedmiotu niniejszej umowy,</li>
    <li>zostały po zawarciu niniejszej umowy pozyskane przez Stronę od podmiotów trzecich, które z kolei nie pozyskały takiej informacji bezpośrednio lub pośrednio od drugiej Strony i nie naruszyły w inny sposób jakiegokolwiek zobowiązania poufności.</li>
    </ol>
  </li>
<li>Zleceniobiorca zobowiązuje się zachować w tajemnicy wszelkie niewymienione w ust. 2 informacje, których ujawnienie mogłoby narazić Zleceniodawcę na szkodę.</li>
<li>W przypadku gdy Strona, zgodnie z ogólnie obowiązującymi przepisami prawa, w szczególności na wezwanie organów działających w granicach swoich uprawnień ujawni informacje poufne przekazane jej przez drugą Stronę w ramach realizacji niniejszej umowy, ograniczenia wynikające z niniejszego paragrafu nie znajdą zastosowania i działanie takie nie będzie rodziło po stronie Strony ujawniającej informacje żadnej odpowiedzialności.</li>
<li>Strony zobowiązują się chronić opisane w niniejszym paragrafie informacje poufne w okresie realizacji niniejszej umowy, a także w okresie 36 (trzydziestu sześciu) miesięcy po jej rozwiązaniu lub wygaśnięciu.</li>
<li>W przypadku naruszenia zobowiązań wynikających z niniejszego paragrafu Strona naruszająca zapłaci na żądanie drugiej Strony karę umowną w kwocie 20 000,00 (słownie: dwadzieścia tysięcy) złotych.</li>
<li>Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego w/w kary umownej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Zgoda na wykorzystanie wizerunku</strong>
</p>
  <ol>
    <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy. Wizerunek będzie wykorzystywany przez Zleceniodawcę w związku z wykonywaniem zleconych zadań określonych w § 1 w celu zapewnienia najwyższych standardów obsługi klienta. Zgoda na wykorzystanie wizerunku stanowi załącznik do niniejszej umowy.</li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Rozwiązanie umowy
</strong>
</p>
<ol>
  <li>Niniejsza umowa może być rozwiązana przez każdą ze stron z zachowaniem ... okresu wypowiedzenia.</li>
  <li>Zleceniodawca ma prawo do rozwiązania niniejszej umowy ze skutkiem natychmiastowym w razie naruszenia przez Zleceniobiorcę postanowień niniejszej umowy lub braku możliwości dalszego powierzenia przedmiotu umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Doręczenia i korespondencja</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy tradycyjne podane w oznaczeniu stron,  uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 11 Spory i sąd właściwy</strong>
</p>
<p>
 Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 (czternastu) dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.
</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Umowa niniejsza rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umowa nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 13 Klauzula salwatoryjna</strong>
</p>
<p>
Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.
</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Liczba egzemplarzy umowy</strong>
</p>
<p>Umowa niniejsza została sporządzona w 2 (dwóch) jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>

<div>
  <p class="underline">Załączniki:</p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu rozmów telefonicznych</li>
    <li class="underline">Oświadczenie Zleceniobiorcy</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">...</span><br>
        <span style="margin-left: 0%;">(Zleceniodawca)</span>
    </div>
    <div class="right-cointainer">
        ...<br>
        <span style="margin-left: 0%;">(Zleceniobiorca)</span>
    </div>
</div>
<br><br>

 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza  zgoda  obejmuje  następujące  pola  eksploatacji:  wykorzystanie,  utrwalanie, obróbkę  i  powielanie  wykonanych  zdjęć/nagrań,  obrót  egzemplarzami,  na  których  utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie   oraz   publikowanie,   w   materiałach służących   działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
   <div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p> Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p>Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p>Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu </p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p>Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO. </p>
  <p>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p>Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p>Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p>Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p>Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
  <p style="margin-top: 75px;">...</p>
  <p>Podpis</p>
  </div>
  </div>

<div style="page-break-before: always;">
  <p align="right" style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia {{ aktualnaData() }} r.
  </p>
  <p><em>Załącznik nr 3</em></p>
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania upoważnienia przez obie strony
</p>
<p class="p-margin">
  upoważniam Pana/Panią ... – Zleceniobiorcę Tutore Poland Sp. z o.o. w dziale Call Center
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
<p class="p-margin">
  w wersji elektronicznej:
</p>
      <ul>
        <li>
          zbiór danych osobowych potencjalnych Klientów pozyskanych z baz Present-Service i Marketing Relacji w celach telemarketingowych – imię i nazwisko, telefon kontaktowy,
        </li>
        <li>
          zbiór danych osobowych Uczestników: dzieci, młodzieży i dorosłych korzystających z usług prowadzonych przez Tutore Poland Sp. z o.o. - imię i nazwisko, klasa (jeśli dotyczy), adres zamieszkania,
        </li>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci i młodzieży korzystających z usług oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
        </li>
        <li>
          zbiór nagrań audio rozmów telefonicznych prowadzonych przez konsultantów Call Center z Klientami wyłącznie trakcie szkoleń – imię i nazwisko, głos,
        </li>
      </ul>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady  (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych. 
  <br>
  Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<div style="page-break-before: always;">
<div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
          </li>
          <li>
            zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
          </li>
        </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>

  <p style="text-align: center;">{{ aktualnaData() }} - ...</p>
  <p class="subheading p-margin" style="text-align: center;">
  {{ zamawiajacy }}
  <br>
  <strong>w imieniu Administratora</strong>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
</div>

<div style="page-break-before: always;">
      <p><em>Załącznik nr 4</em></p>
  <strong>Informacja o monitoringu rozmów telefonicznych</strong>
  <br>
Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring rozmów telefonicznych prowadzonych z klientami firmy, w ramach prowadzonej obsługi telefonicznej. Monitoringiem są objęte telefony o połączeniu VoIP (Voice over Internet Protocol) znajdujące się w siedzibie Tutore Poland Sp. z o.o.. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów jakości obsługi klienta, szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa pracownikom/zleceniobiorcom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony klientów (np. groźby karalne). Informujemy, iż: system monitoringu rozmów telefonicznych składa się z systemu rejestrującego rozmowę telefoniczną na telefonach typu VoIP oraz serwera, dostęp do zapisu nagrań rozmów telefonicznych w ramach firmy posiada wyłącznie Manager Działu Call Center oraz Zarząd, osoby, które mają wgląd do zarejestrowanych nagrań mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu oraz ewentualnie imienia i nazwiska pracownika/zleceniobiorcy. Administratorem danych osobowych uzyskanych na nagraniach monitoringu rozmów telefonicznych jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.
</div>

<div style="margin-top:40px; page-break-before: always; font-size: 10px;">
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, dnia {{ aktualnaData() }} r.
      </p>
        <p style="font-size: 14px; margin-bottom: 0;">...</p>
        <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
    <p align="center" class="subheading">
      <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
    </p>
<ol>
  <li>
    Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
  </li>
  <li>
    Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
  </li>
  <li>
    Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
  </li>
  <li>
    Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
    <ol type="a">
      <li>
        zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
      </li>
      <li>
        wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
      </li>
      <li>
        potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
      </li>
      <li>
        realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
      </li>
      <li>
        bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
      </li>
      <li>
        zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
      </li>
    </ol>
  </li>
  <li>
    Odbiorcami Pani/Pana danych osobowych będą:
    <ul>
      <li>
        organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
      </li>
      <li>
        zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
      </li>
      <li>
        podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
      </li>
      <li>
        biura księgowe:
      </li>
      <li>
        banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
      </li>
      <li>
        kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy; 
      </li>
      <li>
        współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
      </li>
      <li>
        podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
      </li>
      <li>
        instytucje ubezpieczeniowe
      </li>
      <li>
        organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)
      </li>
      <li>
        podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
      </li>
    </ul>
  </li>
  <li>
    Ma Pani/Pan prawo do:
    <ol type="a">
      <li>
        <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
      </li>
      <li>
        <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
      </li>
      <li>
        <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
      </li>
      <li>
        <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
      </li>
      <li>
        <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
        <ol type="i">
          <li>
            kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
          </li>
          <li>
            przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
          </li>
          <li>
            Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
          </li>
          <li>
            wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
          </li>
        </ol>
      </li>
      <li>
        <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
      </li>
      <li>
        <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
      </li>
      <li>
        <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
        <ul type="-">
          <li>
            pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
          </li>
          <li>
            elektronicznie za pośrednictwem platformy ePUAP.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li>
    W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
  </li>
  <li>
    Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
  </li>
</ol>
</div>

  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 14px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
        Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o monitoringu rozmów telefonicznych oraz Klauzulą Informacyjną i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          <br>
          <div class="right-cointainer" style="float: right;">
        ...
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>

    <div style="margin-top:5px;page-break-before: always;">
  <p><em>Załącznik nr 5</em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span></span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>

  </td></tr>
  </tbody></table>
</template>

<script>
export default {
  name: 'WzorUmowaKonsultantCCZdalny2023.vue',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      shortUmowa: '',
      wypoSlownie: '',
      zdalnie: '',
      obywatelstwo: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      tab = this.nrumowy.split('/')
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/CC`
      return this.shortUmowa
    },
    okresWypo () {
      switch (this.wypo) {
        case '5 dni roboczych':
          this.wypoSlownie = '5-dniowego'
          break
        case '7 dni roboczych':
          this.wypoSlownie = '7-dniowego'
          break
        case '14 dni roboczych':
          this.wypoSlownie = '14-dniowego'
          break
      }
      return this.wypoSlownie
    },
    dataStartuUmowy () {
        if (this.datapocz === '30-12-1899') {
          return ''
        } else {
          return `od ${this.datapocz} r.`
        }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.cointainer-right {
  width: 20%;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WzorUmowaKonsultantCCZdalny2023.vue